import React, { useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListSubheader,
} from "@mui/material";

const groupedOptions = {
  Family: [
    { value: "FATHER", label: "Father" },
    { value: "MOTHER", label: "Mother" },
    { value: "FATHER-IN-LAW", label: "Father-in-law" },
    { value: "MOTHER-IN-LAW", label: "Mother-in-law" },
    { value: "SPOUSE", label: "Spouse" },
    { value: "BROTHER", label: "Brother" },
    { value: "SISTER", label: "Sister" },
    { value: "SON", label: "Son" },
    { value: "SON-IN-LAW", label: "Son-in-law" },
    { value: "DAUGHTER", label: "Daughter" },
    { value: "DAUGHTER-IN-LAW", label: "Daughter-in-law" },
    { value: "GRANDSON", label: "Grandson" },
    { value: "GRANDDAUGHTER", label: "Granddaughter" },
  ],
  Medical: [
    { value: "DOCTOR", label: "Doctor" },
    { value: "SOCIAL_WORKER", label: "Social Worker" },
    { value: "DISCHARGE_PLANNER", label: "Discharge Planner" },
    { value: "GERIATRIC_CARE_MANAGER", label: "Geriatric Care Manager (GCM)" },
    { value: "NURSE", label: "Nurse" },
  ],
  Other: [
    { value: "FRIEND", label: "Friend" },
    { value: "NEIGHBOR", label: "Neighbor" },
    { value: "INSURANCE_COMPANY", label: "Insurance Company" },
    { value: "OTHER", label: "Other" },
  ],
};

const RelationshipSelect = ({
  id,
  label,
  value,
  onChange,
  required,
  disabled: propDisabled,
  readonly,
  formContext,
  rawErrors = [],
  options = {},
}) => {
  const isFillingForSomeoneElse =
    formContext?.formData?.formSubmissionDetails?.isFillingForSomeoneElse;

  const isDisabled = options?.dependDisabled
    ? isFillingForSomeoneElse !== "Yes"
    : propDisabled;

  // Clear the value if it's now disabled and has a value
  useEffect(() => {
    if (isDisabled && value) {
      onChange(undefined); // clear the value
    }
  }, [isDisabled, value, onChange]);

  const menuItems = Object.entries(groupedOptions).flatMap(
    ([group, options]) => [
      <ListSubheader
        key={`header-${group}`}
        style={{ fontWeight: "bold", fontSize: "1rem" }}
      >
        {group}
      </ListSubheader>,
      ...options.map((opt) => (
        <MenuItem
          key={opt.value}
          value={opt.value}
          style={{ fontSize: "0.875rem" }}
        >
          {opt.label}
        </MenuItem>
      )),
    ]
  );

  return (
    <FormControl fullWidth error={!!rawErrors.length} disabled={isDisabled}>
      <InputLabel id={`${id}-label`}>
        {label}
        {required && " *"}
      </InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value || ""}
        onChange={(e) =>
          onChange(e.target.value === "" ? undefined : e.target.value)
        }
        disabled={isDisabled || readonly}
        fullWidth
        label={`${label}${required ? " *" : ""}`}
      >
        {menuItems}
      </Select>
    </FormControl>
  );
};

export default RelationshipSelect;
